export const EventReplayAccess = {
  INCLUDED: 'INCLUDED',
  DISABLED: 'DISABLED',
  PAID_SEPARATELY: 'PAID_SEPARATELY',
} as const;
export type EventReplayAccess = (typeof EventReplayAccess)[keyof typeof EventReplayAccess];

export const EventVisibility = {
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE',
  UNLISTED: 'UNLISTED',
} as const;
export type EventVisibility = (typeof EventVisibility)[keyof typeof EventVisibility];

export const EventAccessModel = {
  FREE: 'FREE',
  PAID: 'PAID',
  SUBSCRIPTION: 'SUBSCRIPTION',
} as const;
export type EventAccessModel = (typeof EventAccessModel)[keyof typeof EventAccessModel];

export const EventProductionMode = {
  SELF: 'SELF',
  HIRE: 'HIRE',
} as const;
export type EventProductionMode = (typeof EventProductionMode)[keyof typeof EventProductionMode];

export const EventStreamingMode = {
  PHONE: 'PHONE',
  WEB: 'WEB',
} as const;
export type EventStreamingMode = (typeof EventStreamingMode)[keyof typeof EventStreamingMode];

/**
 * Enum for event allow list type.
 */
export const EventAllowListType = {
  EMAIL: 'EMAIL',
  DOMAIN: 'DOMAIN',
  PHONENUMBER: 'PHONENUMBER',
  USERID: 'USERID',
} as const;
export type EventAllowListType = (typeof EventAllowListType)[keyof typeof EventAllowListType];

export const EventState = {
  DRAFT: 'DRAFT',
  SCHEDULED: 'SCHEDULED',
  READY_FOR_TEST: 'READY_FOR_TEST',
  LIVE: 'LIVE',
  ENDED: 'ENDED',
  REPLAY_READY: 'REPLAY_READY',
  ARCHIVED: 'ARCHIVED',
  CANCELLED: 'CANCELLED',
  PAUSED: 'PAUSED',
  FAILED: 'FAILED',
} as const;
export type EventState = (typeof EventState)[keyof typeof EventState];

export const EventCategory = {
  ART: 'ART',
  TECHNOLOGY: 'TECHNOLOGY',
  SCIENCE: 'SCIENCE',
  TRAVEL: 'TRAVEL',
  HISTORY: 'HISTORY',
  LITERATURE: 'LITERATURE',
  COOKING: 'COOKING',
  FITNESS: 'FITNESS',
  PHOTOGRAPHY: 'PHOTOGRAPHY',
  GARDENING: 'GARDENING',
  EDUCATION: 'EDUCATION',
  FASHION: 'FASHION',
  MOVIES: 'MOVIES',
  SPORTS: 'SPORTS',
  POLITICS: 'POLITICS',
  HEALTH: 'HEALTH',
  GAMING: 'GAMING',
  FINANCE: 'FINANCE',
  NATURE: 'NATURE',
  CONCERT: 'CONCERT',
  FESTIVAL: 'FESTIVAL',
  WEDDING: 'WEDDING',
  CORPORATE: 'CORPORATE',
  RELIGIOUS: 'RELIGIOUS',
  BIRTHDAY: 'BIRTHDAY',
  PARTY: 'PARTY',
  OTHER: 'OTHER',
} as const;
export type EventCategory = (typeof EventCategory)[keyof typeof EventCategory];

export const RegistrationStatus = {
  PENDING_PAYMENT: 'PENDING_PAYMENT',
  ACTIVE: 'ACTIVE',
  CANCELLED: 'CANCELLED',
  REFUNDED: 'REFUNDED',
  EXPIRED: 'EXPIRED',
};
export type RegistrationStatus = (typeof RegistrationStatus)[keyof typeof RegistrationStatus];
export const RegistrationScope = {
  FREE_RSVP: 'FREE_RSVP',
  PAID_TICKET: 'PAID_TICKET',
  INVITE: 'INVITE',
};
export type RegistrationScope = (typeof RegistrationScope)[keyof typeof RegistrationScope];

export const ViewerRegistrationView = {
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
  NONE: 'NONE',
};
export type ViewerRegistrationView =
  (typeof ViewerRegistrationView)[keyof typeof ViewerRegistrationView];

export const DiscoverEvents = {
  UPCOMING: 'UPCOMING',
  LIVE: 'LIVE',
  RECOMMENDED: 'RECOMMENDED',
};
export type DiscoverEvents = (typeof DiscoverEvents)[keyof typeof DiscoverEvents];

export const MyEventsTabSchema = {
  UPCOMING: 'UPCOMING',
  LIVE: 'LIVE',
  PAST: 'PAST',
};
export type MyEventsTabSchema = (typeof MyEventsTabSchema)[keyof typeof MyEventsTabSchema];

export const EntitlementKind = {
  REGISTRATION: 'REGISTRATION',
  REPLAY_PURCHASE: 'REPLAY_PURCHASE',
} as const;
export type EntitlementKind = (typeof EntitlementKind)[keyof typeof EntitlementKind];
